<template>
  <a v-if="billboard.active" @mouseenter="handleMouseEnter" @mouseleave="handleMouseOut" :href="billboard.url" target="_blank"
     ref="billboardRoot" class="app-billboard" :style="{backgroundColor: billboard.colorBackground}">
    <div ref="billboardContent" class="app-billboard__content" :style="{transform: `translate3d(${offset}px, 0, 0)`}">
      <div class="app-billboard__content__item" :style="{color: billboard.colorText}" v-for="clone in clones" :key="clone">
        {{ billboard.title }}
      </div>
    </div>
  </a>
</template>
<script>
import axios from "axios";
let then = Date.now();
export default {
  name: "AppBillboard",
  data() {
    return {
      interval: 1000 / 30,
      direction: 'left',
      rate: 2,
      clones: 2,
      animationFrameId: null,
      offset: 0,
      isPaused: false,
      billboard: {
        active: false,
        colorBackground: '',
        colorText: '',
        title: '',
        url: ''
      }
    }
  },
  async mounted() {
    const {data} = await this.getBillboardData();
    this.billboard.active = data.active;
    this.billboard.url = data.url;
    this.billboard.title = data.title;
    this.billboard.url = data.url;
    this.billboard.colorText = data.colorText;
    this.billboard.colorBackground = data.colorBackground;
    // wait to render
    await this.$nextTick();
    if (this.billboard.active) {
      this.calculateClones();
      window.addEventListener('resize', this.calculateClones, false);
      this.$root.$el.classList.add('billboard-active');
      this.start();
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateClones, false);
  },
  methods: {
    calculateClones(){
      if (this.$refs.billboardContent.firstElementChild.offsetWidth < window.innerWidth) {
        this.clones = Math.round(window.innerWidth / this.$refs.billboardContent.firstElementChild.offsetWidth) + 1;
      }
    },
    async getBillboardData(){
      return await axios.get(`${this.$router.options.api}/front/front-page-billboard`);
    },
    start() {
      this.animate();
    },
    stop() {
      cancelAnimationFrame(this.animationFrameId);
    },
    animate() {
      if (this.isPaused) return;
      // this.animationFrameId = requestAnimationFrame(this.animate);
      let now = Date.now();
      let delta = now - then;
      if (delta > this.interval) {
        then = now - (delta % this.interval);
        if (this.direction === 'left') {
          const firstListItem = this.$refs.billboardContent.firstElementChild;
          let rightSideOfFirstItem = Math.floor(firstListItem.getBoundingClientRect().right);
          if (rightSideOfFirstItem <= this.$refs.billboardRoot.getBoundingClientRect().left) {// APPEND FIRST ITEM TO END
            this.offset = -1;
            this.$refs.billboardContent.appendChild(firstListItem);
          }
          this.offset = this.offset -= this.rate;
        }

        if (this.direction === 'right') {
          const lastListItem = this.$refs.billboardContent.lastElementChild;
          let rightSideOfFirstItem = Math.floor(lastListItem.getBoundingClientRect().left);
          if (rightSideOfFirstItem >= this.$refs.billboardRoot.getBoundingClientRect().right) {
            this.offset = this.offset - lastListItem.getBoundingClientRect().width;
            this.$refs.billboardContent.insertBefore(lastListItem, this.$refs.billboardContent.firstElementChild);
          }
          this.offset = this.offset += this.rate;
        }
      }
      this.animationFrameId = requestAnimationFrame(this.animate);
    },
    handleMouseEnter() {
      this.isPaused = true;
      this.stop();
    },
    handleMouseOut() {
      this.isPaused = false;
      this.start();
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/sass/abstracts/variables";
$billboardHeight: 40px;

.app-billboard {
  position: fixed;
  top: calc(var(--headerHeight) - #{$billboardHeight} + var(--offsetBillboardTop));
  height: 40px;
  width: 100%;
  background-color: red;
  z-index: 999;
  overflow-x: hidden;

  &:hover {
    filter: brightness(.89);
  }

  &__content {
    display: flex;
    height: 100%;
    align-items: center;

    &__item {
      padding-right: 15px;
      flex: 0 0 auto;
      color: black;
      @include font-18-md();
    }
  }
}
</style>
